import toggleModal from '@/scripts/utils/toggle-modal';
import { DOCUMENT_ELEMENT, KEY_CODES } from '@/scripts/constants';
import transitionend from '@/scripts/utils/transitionend';
import isMobile from '@/scripts/utils/detect-mobile';
import Hammer from 'hammerjs';
import './VideoModal.scss';

const defaults = {
  triggerElements: [],
  modalElement: '[data-role*="video-modal-element"]',
  modalContent: '[data-role*="video-modal-content"]',
  modalClose: '[data-role*="video-modal-close"]',
  activeClass: 'video-modal-opened',
  loadingClass: 'is-loading',
};

export default class VideoModal {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.triggerElements = options.triggerElements;
    if (!this.triggerElements.length) return;
    this.modal = document.querySelector(options.modalElement);
    this.modalContent = this.modal.querySelector(options.modalContent);
    this.closeElement = this.modal.querySelector(options.modalClose);
    this.activeClass = options.activeClass;
    this.loadingClass = options.loadingClass;

    this.init();
  }

  toggleStatus(allow) {
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass, allow);
    return toggleModal(
      allow,
      null,
      this.modal,
    );
  }

  initModal(el) {
    const { params } = el.dataset;
    const { type, url, data } = JSON.parse(params);
    this.toggleStatus(true);
    this.modal.classList.add(this.loadingClass);
    $.ajax({
      type,
      url,
      data,
      success: (result) => {
        $(this.modalContent).append(result);
        const $video = $(this.modalContent).find('video');
        $video.on('canplay', () => {
          $video[0].play();
          this.modal.classList.remove(this.loadingClass);
        });
      },
    });
  }

  get activeStatus() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  destroyModal() {
    this.toggleStatus(false);
    transitionend(this.modal, 'transitionend', () => {
      $(this.modalContent).children().remove();
    });
  }

  initKeyboardNav() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_CODES.ESC && this.activeStatus) {
        this.destroyModal();
      }
    });
  }

  initMobileNav() {
    const hammer = new Hammer(this.modal);
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
    hammer.on('swipeup', () => {
      if (this.activeStatus) this.destroyModal();
    });
  }

  initTriggers(triggers) {
    triggers.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.initModal(el);
      });
    });
  }

  init() {
    this.initKeyboardNav();
    if (isMobile()) {
      this.initMobileNav();
    }
    this.initTriggers(this.triggerElements);
    DOCUMENT_ELEMENT.addEventListener('updateVideoModalTriggers', (e) => {
      this.initTriggers(e.detail.triggers);
    });
    this.closeElement.addEventListener('click', () => {
      this.destroyModal();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/VideoModal/VideoModal.js